var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faFileChartColumn } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Link, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StatusPermission } from '../../enum';
import { useUserPermissionsAPI } from '../app/selectors';
import { DownloadTemplateDialog } from '../downloadTemplate';
import { PageBody, SubTitle } from '../layout/styled';
import { CreatePlanDialog } from './createPlanDialog';
import { PlanTable } from './planTable';
export var Home = function (props) {
  var availableIntegrations = props.availableIntegrations;
  var t = useTranslation('myPlans').t;
  var _a = useState(false),
    openDownloadTemplateDialog = _a[0],
    setOpenDownloadTemplateDialog = _a[1];
  var _b = useState(false),
    openCreatePlanDialog = _b[0],
    setOpenCreatePlanDialog = _b[1];
  var userPermission = useUserPermissionsAPI();
  return _jsxs(PageBody, {
    children: [_jsxs(Typography, __assign({
      variant: "h1"
    }, {
      children: [_jsx(FontAwesomeIcon, {
        icon: faFileChartColumn
      }), "\u00A0\u00A0", t('title')]
    })), _jsxs(Box, __assign({
      sx: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        mb: 3
      }
    }, {
      children: [_jsxs(SubTitle, __assign({
        sx: {
          mb: 0
        }
      }, {
        children: [_jsx("span", {
          children: t('subTitle')
        }), _jsx("span", {
          children: t('downloadSubTitle')
        }), _jsx(Link, __assign({
          sx: {
            verticalAlign: 'top'
          },
          component: "button",
          onClick: function () {
            return setOpenDownloadTemplateDialog(true);
          }
        }, {
          children: t('downloadThisTemplate')
        }))]
      })), _jsx(Button, __assign({
        disabled: (userPermission === null || userPermission === void 0 ? void 0 : userPermission.capacityPermission) !== StatusPermission.Edit,
        variant: "contained",
        onClick: function () {
          return setOpenCreatePlanDialog(true);
        },
        sx: {
          minWidth: '200px',
          flexShrink: 0
        }
      }, {
        children: t('createPlan')
      }))]
    })), _jsx(PlanTable, {}), props.children, _jsx(DownloadTemplateDialog, {
      open: openDownloadTemplateDialog,
      onClose: function () {
        return setOpenDownloadTemplateDialog(false);
      }
    }), _jsx(CreatePlanDialog, {
      open: openCreatePlanDialog,
      onClose: function () {
        return setOpenCreatePlanDialog(false);
      },
      handleImport: props.handleImport,
      defaultValues: props.defaultValues,
      availableIntegrations: availableIntegrations
    })]
  });
};